import { axios, AxiosResponse } from '@/config/plugins/axios';
import { TermCondition } from '@/types';

/** service for call the terms conditions api */
const termConditionService = {
	/** get term condition by type {GET} for not connected User */
	getLastByType(type: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/terms-conditions/type/${type}/latest`);
	},
	validateTermCondition(type: string, termCondition: TermCondition): Promise<AxiosResponse<any>> {
		return axios.post(`/api/terms-conditions/type/${type}/validate`, { version: termCondition.version });
	}
};

export default termConditionService;
